<template>
  <div class="wrap">
    <ul class="side-bar">
      <li
        :class="{'cur':curNav==index}"
        v-for="(nav,index) in navs"
        @click="scrollFixed(index)"
      >{{nav}}</li>
    </ul>
    <div class="header">
      <h1>
        <img src="static/images/title.png" alt="复盘神器">
      </h1>
    </div>
    <div class="main">
      <div class="mod">
        <h2>
          <i>1</i>操盘笔迹
        </h2>
        <div class="block-bg summary" ><p v-html="cpbj"></p></div>
      </div>
      <div class="mod">
        <h2>
          <i>2</i>主流板块
        </h2>
        <div class="board-list" v-html="zlbkhq"></div>
      </div>
      <bkyd>
        <!--板块异动-->
      </bkyd>
      <ccwd>
        <!--持仓温度-->
      </ccwd>
      <fbl>
        <!--封板率-->
      </fbl>
      <lszj>
        <!--两市资金-->
      </lszj>
      <zdtj>
        <!--涨跌统计-->
      </zdtj>
      <zdtzs>
        <!--涨跌停走势-->
      </zdtzs>
      <zrztjrbx>
        <!--昨日涨停今日表现-->
      </zrztjrbx>
      <zddb>
        <!--涨跌对比-->
      </zddb>
      <dkdb>
        <!--多空对比-->
      </dkdb>
      <zysj>
        <!--重要事件-->
      </zysj>
      <ztsx>
        <!--涨停筛选-->
      </ztsx>
      <div class="mod clearfix mod-select">
        <h2>
          <i>14</i>涨停分析
        </h2>
        <div class="select">
          <input type="text" id="date_1" v-bind:value="otime" readonly="readonly">
        </div>
        <div class="select-content">
          <ul class="select-content-list" v-html="ztfx"></ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bkyd from "./components/bkyd";
import zysj from "./components/zysj";
import ztsx from "./components/ztsx";
import ccwd from "./components/ccwd";
import fbl from "./components/fbl";
import lszj from "./components/lszj";
import zdtj from "./components/zdtj";
import zdtzs from "./components/zdtzs";
import zrztjrbx from "./components/zrztjrbx";
import zddb from "./components/zddb";
import dkdb from "./components/dkdb";
import { constants } from 'fs';

export default {
  name: "Home",
  components: {
    bkyd,
    zysj,
    ztsx,
    ccwd,
    fbl,
    lszj,
    zdtj,
    zdtzs,
    zrztjrbx,
    zddb,
    dkdb
  },
  data() {
    return {
      curNav: 0,
      navs: [
        "操盘笔迹",
        "主流板块",
        "板块异动",
        "持仓温度",
        "封板率",
        "两市资金",
        "涨跌统计",
        "涨跌停走势",
        "昨日涨停今日表现",
        "涨跌对比",
        "多空对比",
        "重要事件",
        "一键涨停筛选",
        "涨停分析"
      ],
      cpbj: null,
      ztfx: null,
      zlbk: null,
      zlbkhq: null,
      otime: null
    };
  },
  methods: {
      handleScroll() {
          var _this  = this;
          var lev1	=  $(".mod").eq(0).offset().top;
          var lev2	=  $(".mod").eq(1).offset().top;
          var lev3	=  $(".mod").eq(2).offset().top;
          var lev4	=  $(".mod").eq(3).offset().top;
          var lev5	=  $(".mod").eq(4).offset().top;
          var lev6	=  $(".mod").eq(5).offset().top;
          var lev7	=  $(".mod").eq(6).offset().top;
          var lev8	=  $(".mod").eq(7).offset().top;
          var lev9	=  $(".mod").eq(8).offset().top;
          var lev10	=  $(".mod").eq(9).offset().top;
          var lev11	=  $(".mod").eq(10).offset().top;
          var lev12	=  $(".mod").eq(11).offset().top;
          var lev13	=  $(".mod").eq(12).offset().top;
          var lev14	=  $(".mod").eq(13).offset().top;
          let y = window.scrollY
          if (y >= 0 && y<lev1) {
              _this.curNav = 0;
              $(".mod").eq(_this.curNav).offset().top -$(".nav").height() - 10
          }
          if (y >= lev1 && y<lev2) {
              _this.curNav = 1;
              $(".mod").eq(_this.curNav).offset().top -$(".nav").height() - 10
          }
          if (y >= lev2 && y<lev3) {
              _this.curNav = 2;
              $(".mod").eq(_this.curNav).offset().top -$(".nav").height() - 10
          }

          if (y >= lev3 && y<lev4) {
              _this.curNav = (_this.curNav == 4)?4:3;
              $(".mod").eq(_this.curNav).offset().top -$(".nav").height() - 10
          }
          if (y >= lev5 && y<lev6) {
              _this.curNav = (_this.curNav == 6)?6:5;
              $(".mod").eq(_this.curNav).offset().top -$(".nav").height() - 10
          }
          if (y >= lev7 && y<lev8) {
              _this.curNav = (_this.curNav == 8)?8:7;
              $(".mod").eq(index).offset().top -$(".nav").height() - 10
          }
          if (y >= lev9 && y<lev10) {
              _this.curNav = (_this.curNav == 10)?10:9;
              $(".mod").eq(_this.curNav).offset().top -$(".nav").height() - 10
          }

          if (y >= lev11 && y<lev12) {
              _this.curNav = 11;
              $(".mod").eq(_this.curNav).offset().top -$(".nav").height() - 10
          }
          if (y >= lev12 && y<lev13) {
              _this.curNav = 12;
              $(".mod").eq(_this.curNav).offset().top -$(".nav").height() - 10
          }
          if (y >= lev13) {
              _this.curNav = 13;
              $(".mod").eq(_this.curNav).offset().top -$(".nav").height() - 10
          }
      },
    clickDate: function() {},
    scrollFixed: function(index) {
      this.curNav = index;
      $(window).scrollTop(
        $(".mod")
          .eq(index)
          .offset().top -
          $(".nav").height() -
          10
      );
    },
    fmtStr(obj){
      var str = "'VIEWSTOCK?DATATYPE=DAY&LABEL="+obj+"&PAGE=分时走势;VIEWINDI?NUMPIC=3&INDI1=MA&INDI2=VOL;INDI3=SVNS'";
      return str;
    },
    getNewsList: function() {
      let _this = this;
      _this.$http.get(process.env.Zt_url).then(
        res => {
          if (res.status == 200) {
            if (res.data[0]) {
            this.cpbj = res.data[0].data.cpbj;
            this.zlbk = res.data[0].data.zlbk;
            this.otime = res.data[0].data.zdfxlist[0].otime;
            this.getzlbk();
            var html =
              '<table width="100%" cellpadding="0" cellspacing="0" class="select-content-table">';
            res.data[0].data.zdfxlist[0].zdfx.forEach((item, index) => {
              if (index % 2 == 0) {
                html +=
                  '<tr><td width="50%"><a class="content-list-stock" href="javascript:void(0);" onclick="window.external.addcommand('+_this.fmtStr(item.Obj)+')">' +
                  item.name +
                  "<small>" +
                  item.Obj.slice(2) +
                  "</small></a><p>" +
                  item.zdfx +
                  "</p></td>";
              } else {
                html +=
                  '<td width="50%"><a class="content-list-stock" href="javascript:void(0);" onclick="window.external.addcommand('+_this.fmtStr(item.Obj)+')">' +
                  item.name +
                  "<small>" +
                  item.Obj.slice(2) +
                  "</small></a><p>" +
                  item.zdfx +
                  "</p></td></tr>";
              }
            });
            this.ztfx = html;
          }else{
              //没有数据处理
               this.ztfx = '<div class="select-blank"><p><span>温馨提示：</span>该日无涨停个股或涨停个股无分析数据！</p><p><span>咨询电话：</span>021-20219999</p></div>';
              
          }
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    fmtStr1(obj){
      var str = "'VIEWSTOCK?LABEL="+obj+"&PAGE=分时走势&LEADER=1'";
      return str;
    },
    getzlbk() {
      var _this = this;
      dzhyun
        .subscribe(
          "/stkdata",
          {
            field: "ZhongWenJianCheng,ZuiXinJia,ZhangFu,HuanShou",
            obj: this.zlbk,
            mode: 2
          },
          resStockList => {
            var html = "";
          
            resStockList.forEach(item => {
              if (item.ZhangFu == null) {
                 html +=
                  '<a href="javascript:void(0);" onclick="window.external.addcommand('+_this.fmtStr1(item.Obj)+')" class="board-red">' +
                  item.ZhongWenJianCheng +
                  '<span  >' +
                  
                  "-</span></a>";
              }else if (item.ZhangFu > 0) {
                html +=
                  '<a  href="javascript:void(0);" onclick="window.external.addcommand('+_this.fmtStr1(item.Obj)+')"  class="board-red">' +
                  item.ZhongWenJianCheng +
                  '<span  style="color:red" >' +
                  item.ZhangFu +
                  "%</span></a>";
              } else if (item.ZhangFu == 0) {
                html +=
                  '<a  href="javascript:void(0);" onclick="window.external.addcommand('+_this.fmtStr1(item.Obj)+')" class="board-red">' +
                  item.ZhongWenJianCheng +
                  "<span   >" +
                  item.ZhangFu +
                  "%</span></a>";
              } else if (item.ZhangFu < 0) {
                html +=
                  '<a  href="javascript:void(0);" onclick="window.external.addcommand('+_this.fmtStr1(item.Obj)+')" class="board-green">' +
                  item.ZhongWenJianCheng +
                  '<span  style="color:green" >' +
                  item.ZhangFu +
                  "%</span></a>";
              }
            });
            this.zlbkhq = html;
          }
        )
        .then(function(data) {});
    }
  },
  mounted() {
    
    window.addEventListener('scroll', this.handleScroll);

      // 14-日历控件
    $("#date_1").datepicker({
      dateFormat: "yy年mm月dd日",
      onSelect: function(date, inst) {
        $.ajax({
          type: "get",
          url: process.env.Zt_url,
          dataType: "json",
          success: function(data) {
            
            var ishave = 0;
            var html =
              '<table width="100%" cellpadding="0" cellspacing="0" class="select-content-table">';
            if (data[0]) {
            for (var i = 0; i < data[0].data.zdfxlist.length; i++) {
              if (data[0].data.zdfxlist[i].otime == date) {
                ishave = 1;
                data[0].data.zdfxlist[i].zdfx.forEach((item, index) => {
                  if (index % 2 == 0) {
                    html +=
                      '<tr><td width="50%"><a class="content-list-stock" href="###">' +
                      item.name +
                      "<small>" +
                      item.Obj.slice(2) +
                      "</small></a><p>" +
                      item.zdfx +
                      "</p></td>";
                  } else {
                    html +=
                      '<td width="50%"><a class="content-list-stock" href="###">' +
                      item.name +
                      "<small>" +
                      item.Obj.slice(2) +
                      "</small></a><p>" +
                      item.zdfx +
                      "</p></td></tr>";
                  }
                });
              }
            }
            }
            if (ishave) {
              //加载数据做处理
              $(".select-content-list").html(html);
            } else {
              //没有数据处理
              $(".select-content-list").html(
                '<div class="select-blank"><p><span>温馨提示：</span>该日无涨停个股或涨停个股无分析数据！</p><p><span>咨询电话：</span>021-20219999</p></div>'
              );
            }
          },
          error: function(XMLHttpRequest, textStatus, errorThrown) {
            alert(errorThrown);
          }
        });
      }
    });
    //获取操盘笔记、主流板块、涨停分析json文件
    this.getNewsList();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/home/Home.vue